export default "__VITE_ASSET__7655e858__"